module.exports = __webpack_public_path__ + "img/changeFineness-1@2x.7bce771.webp";